module.exports = __webpack_public_path__ + "static/media/libreta (1).bdfac0c3.JPG";